<template>
  <div>
    <div><img :src="toppic" class="pic"></div>
    <div class="respx" v-show="isShowRes">
      <p style="text-align:center;"><img :src="ewmpic1" class="ewmpic"></p>
      <div style="text-align:center; height:0.1rem; line-height:1.8; color:#333333;font-size: 0.048rem;">提交成功!</div>
      <p style="text-align:center;"><img :src="ewmpic2" class="ewmpic"></p>
      <div style="text-align:center; height:0.12rem; line-height:1.2; color:#666;font-size: 0.04rem;">我们已收到您的反馈，感谢填写！<br>提升游玩体验，我们一直在努力！</div>
      <p style="text-align:center;"><img :src="btnpic" class="btnpic" @click="isShowRes=false"></p>
      
    </div>
    <div class="repx" v-show="!isShowRes">
      <div style="position:relative;">
        <p class="questt" style="position:absolute;top:-0.045rem;font-size: 0.0393333333333rem;">{{shopName}}</p>
        <p class="questt" style="padding-top:0.0255555555rem;">{{ques1}}<span>*</span></p>
        <div class="rowbox">
        <div class="date" @click="showCalendar=true">{{ date?date:'MM-DD' }}</div>
        <div class="time" @click="showPicker=true">{{time}}</div>
        </div>

        <p class="questt" style="padding-top: .02rem;">{{ques2}}<span>*</span></p>
        <p class="notetips">此题可多选<br>勾选后可在右侧文本框内描述吐槽具体内容</p>
        <div class="rowbox">
        <van-checkbox-group v-model="question2">
          <div class="ques2" :key="i" v-for="(item,i) in options2"><van-checkbox icon-size="16px" shape="square" :name="item.tag">{{item.name}}</van-checkbox>
          <input type="text" v-show="item.selected" v-model="item.value" class="txtinput" maxlength="100" />
          </div>
        </van-checkbox-group>
        </div>
      </div>

      <p class="questt">{{ques3}}</p>
      <div class="rowbox">
        <textarea class="txtarea" maxlength="500" v-model="question3" placeholder="建议、吐槽......都可以，我们会认真听取你所说的每一句话！"></textarea>
      </div>

       <p class="questt" style="padding-top: .02rem;">{{ques4}}</p>
       <div class="rowbox">
        <input type="text" class="txtphone" v-model="question4" maxlength="11">
      </div>
    <div class="rowbox" style="padding-top:0.1rem;">
      <van-button type="primary" color="#5688f5" @click="handleSub" block>提交</van-button>
    </div>  
    </div>
    <div><img :src="bompic" class="pic"></div>

    <van-calendar v-model="showCalendar" :min-date="minDate" color="#5688f5" @confirm="onConfirm" />
    <van-popup v-model="showPicker" round position="bottom">
    <van-picker
      show-toolbar
      :columns="['0时','1时','2时','3时','4时','5时','6时','7时','8时','9时','10时','11时','12时','13时','14时','15时','16时','17时','18时','19时','20时','21时','22时','23时']"
      @cancel="showPicker = false"
      @confirm="onPickerConfirm"
    />
  </van-popup>
  </div>
</template>

<script>

export default {
  name: "question",
  data() {
    return {
      isShowRes: false,
      shopName: this.$route.query.shopName || '',
      toppic: require('@a/top.jpg'),
      bompic: require('@a/bom.jpg'),
      ewmpic1:require('@a/ewm_01.jpg'),
      ewmpic2:require('@a/ewm_03.jpg'),
      btnpic:require('@a/btnback.jpg'),
      showCalendar:false,
      showPicker: false,
      minDate: new Date(1990, 0, 1),
      date:'',
      time: '',
      ques1: '1. 您本次到店消费的时间是：',
      ques2: '2. 以下的哪些方面影响了您此次的体验？',
      ques3: '3. 您的更多建议或意见：',
      ques4: '4. 如需回复可留下您的联系方式。',
      options2:[
        {
          name:'声音',
          tag: 'A',
          selected: false,
          value:''
        },
        {
          name:'卫生',
          tag: 'B',
          selected: false,
          value:''
        },
        {
          name:'照明',
          tag: 'C',
          selected: false,
          value:''
        },
        {
          name:'温度',
          tag: 'D',
          selected: false,
          value:''
        },
        {
          name:'配套设施',
          tag: 'E',
          selected: false,
          value:''
        },
        {
          name:'服务',
          tag: 'F',
          selected: false,
          value:''
        },
        {
          name:'其他',
          tag: 'G',
          selected: false,
          value:''
        }
      ],
      question2:[],
      question3:'',
      question4: ''
    };
  },
  created() {
  },
  watch:{
    question2(val){
      this.options2.forEach((item,i) => {
        if(val.includes(item.tag)){
          this.options2[i].selected=true
        }else{
          this.options2[i].selected=false
          this.options2[i].value=''
        }
      })
    }
  },
  mounted() {},
  methods: {
    onConfirm(date) {
      this.showCalendar = false;
      this.date = `${date.getMonth() + 1}-${date.getDate()}`
    },
    onPickerConfirm(value) {
      this.time = value;
      this.showPicker = false;
    },
    handleSub(){
      let shopId = this.$route.query.shopId
      if(this.date==='' || this.time===''){
        this.$toast({ content: '请选择到店消费的时间'})
        return
      }
      if(this.question2.length===0){
        this.$toast({ content: '请选择哪些方面影响了您此次的体验'})
        return
      }
      let reg = /^1\d{10}$/
      if (this.question4!=='' && !reg.test(this.question4)) {
        this.$toast({ content: '请输入正确的联系方式'})
        return
      }
      let question2 = this.options2.filter(item => {
        return this.question2.includes(item.tag)
      })
      let quesArr = [
        { question: this.ques1, answer: this.date + ' ' + this.time },
        { question: this.ques2, answer: question2.map(item => {
          return item.name +':' + item.value
        }).join('|') },
        { question: this.ques3, answer: this.question3 },
        { question: this.ques4, answer: this.question4 }
      ]
      this.API.questionSave({
        merchantId: 'dwj',
        shopId: shopId,
        mobileNumber: this.question4,
        content: JSON.stringify(quesArr)
      }).then(res => {
        if (res.status === 200) {
         this.date= ''
         this.time= ''
         this.question2 = []
         this.question3= ''
         this.question4= ''
         this.isShowRes = true
         window.scrollTo(0,0)
        } else {
          this.$toast({ content: res.error || '提交失败'})
        }
      }).catch(err => {
        this.$toast({ content: err.error || '提交失败'})
      })

    }
  },
};
</script>
<style lang="less" >
.ewmpic{ width:0.79333333333333333333rem; display:inline;}
.btnpic{width:0.42933333333333333333rem; display:inline;}
.pic{ width: 1rem;}
.repx{ width: 1rem; background: url('../../assets/repy.jpg') repeat-y 0 0; background-size:1rem auto; height: 1.9rem;}
.respx{ width: 1rem; background: url('../../assets/repy.jpg') repeat-y 0 0; background-size:1rem auto; min-height:1rem; height:calc(~"100vh - 0.7346666666666666rem");}
.questt{line-height: 1.65;
padding-left: 0.07rem;
padding-right: 0.07rem;
    font-size: 0.034rem;
    font-weight: bold;
    color: #273748;}
.questt span{ margin-left: 5px;color: #da2824;}
.rowbox{ display: flex;padding-left: 0.07rem;padding-right: 0.07rem; padding-top: 0.02rem; padding-bottom:0.02rem;}
.date{ border: 1px solid #d3d3d3; width: 0.5rem; height: 0.07rem; color: #999; line-height: 0.07rem; padding-left: 0.02rem;}
.time{border: #d3d3d3 1px solid; width: 0.3rem; margin-left: 0.05rem; height: 0.07rem; color: #999; line-height: 0.07rem; padding-left: 0.02rem;}
.notetips{ color: #887865;padding-left: 0.07rem;
padding-right: 0.07rem;}

.ques2{ display: flex; padding-bottom: .02rem;}
.ques2 .txtinput{ width: 0.4rem; margin-left: 0.05rem;border: #d3d3d3 1px solid; }
.txtarea{ border: #d3d3d3 1px solid; height: .4rem; width:100%; }
.txtphone{ border: #d3d3d3 1px solid;height: .07rem; width:100%; line-height: 0.07rem; padding-left: 0.02rem; }
</style>